import {
  Component,
  OnInit,
  Inject,
  ChangeDetectorRef,
  ViewEncapsulation,
} from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatSnackBar,
  MatDialog,
  getMatFormFieldDuplicatedHintError,
} from "@angular/material";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray,
} from "@angular/forms";
import { ClipBoardService } from "../../../services/clipboard.service";
import { ServerService } from "../../../services/server.service";
import { DatePipe } from "@angular/common";
import { AddLeadDeliveredComponent } from "../add-lead-delivered/add-lead-delivered.component";
import { ClipBoardService as messageService } from "src/app/services/clipboard.service";

@Component({
  selector: "app-add-feedback",
  templateUrl: "./add-feedback.component.html",
  styleUrls: ["./add-feedback.component.scss"],
  providers: [DatePipe],
})
export class AddFeedbackComponent implements OnInit {
  authToken = localStorage.getItem("token");

  showComponentLoader: boolean = false;

  btnStatus: boolean = false;

  myDateRangePickerOptions = {
    dateFormat: "dd.mm.yyyy",
  };

  addForm: FormGroup;

  headerStats: any;

  currentDate: any = new Date();

  campaignData: any;

  clientFeedbackTobeUpload: any;
  analysisTobeUpload: any;
  platformForm: FormGroup;
  platformList: any;
  errors_feedback: any;
  errors_feedback_platform: any = {};
  errorExist: any;
  platformlistLength: any;
  errorMessage: string;
  leadDeliveredMore = true;
  errorMessageFeedback: string;

  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<AddLeadDeliveredComponent>,
    private clipBoardMessageService: messageService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    // this.platformForm = this.fb.group({
    //   platforms: this.fb.array([])
    // });
    // this.getDropDown();
    this.platformForm = this.fb.group({
      platforms: this.fb.array([]), // Add one default entry
    });
    this.platforms.push(this.createPlatformGroup());
    // this.getFilteredPlatformList(1)
    this.currentDate = this.datePipe.transform(this.currentDate, "yyyy-MM-dd");
    this.campaignData = data;
  }
  get platforms(): FormArray {
    return this.platformForm.get("platforms") as FormArray;
  }
  getDropDown() {
    this.showComponentLoader = true;

    let url = "campaign_module/get_common_details";

    this.serverService.getLeadDeliveryDropDown(url, this.authToken).subscribe(
      (data) => {
        // console.log(data)
        this.platformlistLength = data.feedback_platform_wise_list.length;
        this.platformList = data.feedback_platform_wise_list;
        // console.log(this.platformList)
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken);
      }
    );
  }
  createPlatformGroup(): FormGroup {
    return this.fb.group({
      platform: ["", Validators.required],
      leads_delivered: ["", Validators.required],
      feedback_received: ["", Validators.required],
      leads_qualified: ["", Validators.required],
      leads_qualified_out_of_tat: [""],
      site_visit_proposed: ["", Validators.required],
      site_visit_done: ["", Validators.required],
      csql: ["", Validators.required],
    });
  }
  checkPlatformFormFilled(plaformFilled: any) {
    if (plaformFilled != "") {
      return true;
    }
    return false;
  }
  filteroutPlatform(platform: any) {
    // console.log(platform)
    const selectedPlatforms = platform
      .map((item) => item.platform) // Get the "platform" property
      .filter((platform) => platform); // Remove empty or undefined values

    // Filter platformList
    this.platformList = this.platformList.filter(
      (platform) => !selectedPlatforms.includes(platform)
    );

    // console.log(filteredPlatformList);
    // this.platformList.filter((item)=> item != )
  }
  addPlatform() {
    if (this.platforms.length <= this.platformlistLength) {
      this.platforms.push(this.createPlatformGroup());
    }
    // this.filteroutPlatform(this.platforms.value)
  }
  leadDeliveredPlatform(index: number) {
    const platformsArray = this.platformForm.get("platforms") as FormArray;
    const platformGroup = platformsArray.at(index) as FormGroup;

    const leadsDelivered = platformGroup.get("leads_delivered").value;
    const feedbackReceived = platformGroup.get("feedback_received").value;
   
    if (!this.errors_feedback_platform) {
      this.errors_feedback_platform = {};
    }
    if (!this.errors_feedback_platform[index]) {
      this.errors_feedback_platform[index] = {};
    }

    if (leadsDelivered == 0) {
      this.errors_feedback_platform[index].leads_delivered =
        "*Leads Delivered cannot be Zero.";
      this.leadDeliveredMore = true;
    } else {
      delete this.errors_feedback_platform[index].leads_delivered;
    }

    // if (feedbackReceived === 0) {
    //   this.errors_feedback_platform[index].feedback_received = "*Feedback Received cannot be Zero.";
    //   this.leadDeliveredMore = true;
    // } else {
    //   delete this.errors_feedback_platform[index].feedback_received;
    // }

    if (leadsDelivered != 0 && leadsDelivered < feedbackReceived) {
      this.errors_feedback_platform[index].leads_delivered =
        "*Leads Delivered cannot be less than Feedback Received.";
      this.leadDeliveredMore = true;
    }

    if (Object.keys(this.errors_feedback_platform[index]).length === 0) {
      delete this.errors_feedback_platform[index];
      this.leadDeliveredMore = false;
    }
  }

  leadDelivered() {
    
    const leadsDelivered = Number(this.addForm.value.leads_delivered);
    const feedbackReceived = Number(this.addForm.value.feedback_received);

    // console.log(leadsDelivered)
    // console.log(feedbackReceived)

    this.leadDeliveredMore = false;
    // Validate Leads Delivered
    if (leadsDelivered == 0) {
      this.leadDeliveredMore = true;
      this.errorMessage = "*Leads Delivered cannot be Zero.";
    } else if (leadsDelivered < feedbackReceived) {
      this.leadDeliveredMore = true;
      this.errorMessage =
        "*Leads Delivered cannot be less than Feedback Received.";
    } else {
      this.errorMessage = "";
    }

    // Validate Feedback Received
    if (feedbackReceived == 0) {
      this.leadDeliveredMore = true;
      this.errorMessageFeedback = "*Feedback Received cannot be Zero.";
    } else {
      this.errorMessageFeedback = "";
    }
    // this.validateMetricsMatch()
    this.validateMetricsMatch(this.platformForm);
  }

  getFilteredPlatformList(rowIndex: any): any {
    // console.log(this.platforms.controls)if()
    if (this.platformList) {
      const selectedPlatforms = this.platforms.controls
        .filter((_, i) => i !== rowIndex)
        .map((control: any) => control.get("platform").value)
        .filter((platform: string) => platform);

      return this.platformList.filter(
        (platform) => !selectedPlatforms.includes(platform)
      );
    }
  }

  removePlatform(index: number): void {
    this.platforms.removeAt(index);
  }

  ngOnInit() {
    this.platformForm.setValidators(this.validateMetricsMatch.bind(this));
    this.setDeliveryForm();
    this.getSpentBudgetDeliveryStats();
    this.getDropDown();
  }

  toggleLeadOOT(event: any) {
    // console.log(event.target.value);
    const platforms = this.platforms;
    // console.log(this.platforms.value);
    if (event.target.value) {
      platforms.controls.forEach((platform) => {
        // console.
        platform
          .get("leads_qualified_out_of_tat")
          .setValidators([Validators.required]);
        platform.get("leads_qualified_out_of_tat").updateValueAndValidity();
      });
    } else {
      platforms.controls.forEach((platform) => {
        platform.get("leads_qualified_out_of_tat").clearValidators();
        platform.get("leads_qualified_out_of_tat").updateValueAndValidity();
      });
    }
    // this.validateMetricsMatch(this.platformForm);
  }
  toggleLeadQualified(event: any) {
    // console.log(event.target.value);
    const platforms = this.platforms;
    // console.log(this.platforms.value);
    if (event.target.value) {
      platforms.controls.forEach((platform) => {
        // console.
        platform
          .get("leads_qualified")
          .setValidators([Validators.required]);
        platform.get("leads_qualified").updateValueAndValidity();
      });
    } else {
      platforms.controls.forEach((platform) => {
        platform.get("leads_qualified").clearValidators();
        platform.get("leads_qualified").updateValueAndValidity();
      });
    }
    // this.validateMetricsMatch(this.platformForm);
  }
  toggleSVP(event: any) {
    // console.log(event.target.value);
    const platforms = this.platforms;
    // console.log(this.platforms.value);
    if (event.target.value) {
      platforms.controls.forEach((platform) => {
        // console.
        platform
          .get("site_visit_proposed")
          .setValidators([Validators.required]);
        platform.get("site_visit_proposed").updateValueAndValidity();
      });
    } else {
      platforms.controls.forEach((platform) => {
        platform.get("site_visit_proposed").clearValidators();
        platform.get("site_visit_proposed").updateValueAndValidity();
      });
    }
    
  }
  toggleSVD(event: any) {
    // console.log(event.target.value);
    const platforms = this.platforms;
    // console.log(this.platforms.value);
    if (event.target.value) {
      platforms.controls.forEach((platform) => {
        // console.
        platform
          .get("site_visit_proposed")
          .setValidators([Validators.required]);
        platform.get("site_visit_proposed").updateValueAndValidity();
      });
    } else {
      platforms.controls.forEach((platform) => {
        platform.get("site_visit_proposed").clearValidators();
        platform.get("site_visit_proposed").updateValueAndValidity();
      });
    }
  
    // this.validateMetricsMatch(this.platformForm);
  }
  toggleCSQL(event: any) {
    // console.log(event.target.value);
    const platforms = this.platforms;
    // console.log(this.platforms.value);
    if (event.target.value) {
      platforms.controls.forEach((platform) => {
        // console.
        platform
          .get("csql")
          .setValidators([Validators.required]);
        platform.get("csql").updateValueAndValidity();
      });
    } else {
      platforms.controls.forEach((platform) => {
        platform.get("csql").clearValidators();
        platform.get("csql").updateValueAndValidity();
      });
    }
  
    // this.validateMetricsMatch(this.platformForm);
  }
  getSpentBudgetDeliveryStats() {
    this.showComponentLoader = true;

    //let url = "campaign_module/campaign/spent_budget_delivery_stats/"+this.data.id;
    let url =
      "campaign_module/lead_feedback_analysis/get_lead_feedback_analysis_stats?campaign_id=" +
      this.data.id;

    this.serverService
      .getSpentBudgetDeliveryStats(url, this.authToken)
      .subscribe(
        (data) => {
          //console.log(data)
          this.headerStats = data.stats[0];
          //console.log(this.headerStats)
          this.showComponentLoader = false;
        },
        (err) => {
          this.showComponentLoader = false;
          this.clipBoardService.checkServerError(err, this.authToken);
        }
      );
  }

  selectFile(event: any, uploadSectionType: any): any {
    if (!event.target.files.length) {
      return false;
    }

    //console.log(event.target.files)

    if (uploadSectionType == "clientFeedbackSheet") {
      this.clientFeedbackTobeUpload = event.target.files[0];
    }

    if (uploadSectionType == "analysisSheet") {
      this.analysisTobeUpload = event.target.files[0];
    }

    // console.log(this.clientFeedbackTobeUpload)
    // console.log(this.analysisTobeUpload)
  }

  setDeliveryForm() {
    this.addForm = this.fb.group({
      analysis_at: ["", Validators.compose([Validators.required])],
      leads_delivered: ["", Validators.compose([Validators.required])],
      feedback_received: ["", Validators.compose([Validators.required])],
      leads_qualified: [null, Validators.compose([Validators.required])],
      leads_qualified_out_of_tat: [null,Validators.compose([Validators.required])],
      client_feedback_sheet: [null, Validators.compose([Validators.required])],
      analysis_sheet: [null, Validators.compose([Validators.required])],
      site_visit_proposed: [null, Validators.compose([Validators.required])],
      site_visit_done: [null, Validators.compose([Validators.required])],
      csql: [null, Validators.compose([Validators.required])],
    });
  }

  saveDeliveryForm() {
    if (this.platformForm.invalid) {
      return;
    }
    this.btnStatus = true;

    const formData: FormData = new FormData();

    formData.append("campaign_id", this.campaignData.id);
    formData.append("analysis_at", this.addForm.value.analysis_at);
    formData.append(
      "leads_delivered",
      this.addForm.value.leads_delivered.toString()
    );
    formData.append(
      "feedback_received",
      this.addForm.value.feedback_received.toString()
    );
    formData.append(
      "leads_qualified",
      this.addForm.value.leads_qualified.toString()
    );
    if (this.addForm.value.leads_qualified_out_of_tat) {
      formData.append(
        "leads_qualified_out_of_tat",
        this.addForm.value.leads_qualified_out_of_tat.toString()
      );
    }

    formData.append(
      "leads_site_visit_proposed",
      this.addForm.value.site_visit_proposed.toString()
    );
    formData.append(
      "leads_site_visit_done",
      this.addForm.value.site_visit_done.toString()
    );
    formData.append(
      "current_stage_qualified_leads",
      this.addForm.value.csql.toString()
    );

    formData.append("client_feedback_sheet", this.clientFeedbackTobeUpload);
    formData.append("analysis_sheet", this.analysisTobeUpload);

    formData.append("source_wise", JSON.stringify(this.platformForm.value));
    //  console.log(this.platformForm)
    // return;
    this.serverService
      .saveFeedbackForm(
        "campaign_module/lead_feedback_analysis",
        formData,
        this.authToken
      )
      .subscribe(
        (data) => {
          this.clipBoardMessageService.showMessgeInText(
            "Feedback Added Successfully",
            "success-snackbar"
          );
          this.btnStatus = false;
          this.dialogRef.close(data);
        },
        (err) => {
          this.btnStatus = false;
          this.clipBoardService.checkServerError(err, this.authToken);
        }
      );
  }

  close() {
    this.dialogRef.close();
  }

  onKeyPress(event: KeyboardEvent) {
    const allowedCharacters = /[0-9\+]/;
    const inputChar = String.fromCharCode(event.keyCode);

    if (!allowedCharacters.test(inputChar)) {
      event.preventDefault();
    }
  }

  get leadsDeliveredInAddForm() {
    return this.addForm.get("leads_delivered").value;
  }

  get feedbackReceivedInAddForm() {
    return this.addForm.get("feedback_received").value;
  }

  get leadsQualifiedInAddForm() {
    return this.addForm.get("leads_qualified").value;
  }

  get leadsQualifiedOOTInAddForm() {
    return this.addForm.get("leads_qualified_out_of_tat").value;
  }

  get siteVisitProposedInAddForm() {
    return this.addForm.get("site_visit_proposed").value;
  }

  get siteVisitDoneInAddForm() {
    return this.addForm.get("site_visit_done").value;
  }

  get csqlInAddForm() {
    return this.addForm.get("csql").value;
  }

  validateMetricsMatch(control: FormGroup) {

    const sumMetrics = this.calculateSumOfMetrics();

    this.errors_feedback = {
      leads_delivered:
      Number(this.leadsDeliveredInAddForm) != sumMetrics.leads_delivered
          ? `Leads Delivered does not match the sum`
          : "",
      feedback_received:
      Number(this.feedbackReceivedInAddForm) != sumMetrics.feedback_received
          ? `Feedback Received does not match the sum`
          : "",
      leads_qualified:
        Number(this.leadsQualifiedInAddForm) != sumMetrics.leads_qualified
          ? `Leads Qualified does not match the sum`
          : "",

      site_visit_proposed:
      Number(this.siteVisitProposedInAddForm) != sumMetrics.site_visit_proposed
          ? `Site Visit Proposed does not match the sum`
          : "",
      site_visit_done:
      Number(this.siteVisitDoneInAddForm) != sumMetrics.site_visit_done
          ? `Site Visit Done does not match the sum`
          : "",
      csql:
      Number(this.csqlInAddForm) != sumMetrics.csql
          ? `CSQL does not match the sum`
          : "",
    };
    // console.log(this.addForm.value.leads_qualified_out_of_tat)
    // if(this.addForm.value.leads_qualified_out_of_tat){

    //   // console.log(this.addForm.value.leads_qualified_out_of_tat)
    //     this.errors_feedback.leads_qualified_out_of_tat= this.leadsQualifiedOOTInAddForm !== sumMetrics.leads_qualified_out_of_tat ? `Leads Qualified Out of TAT does not match the sum` : '';
    // }
    const ootControl = this.addForm.get("leads_qualified_out_of_tat");
    const ootValue = ootControl.value;

    if (ootValue !== null && ootValue !== undefined && ootValue !== "") {
      // Validate only if OOT has a value
      this.errors_feedback.leads_qualified_out_of_tat =
        this.leadsQualifiedOOTInAddForm !=
        sumMetrics.leads_qualified_out_of_tat
          ? `Leads Qualified Out of TAT does not match the sum`
          : "";
    } else {
      // If OOT is blank, remove its validation error
      this.errors_feedback.leads_qualified_out_of_tat = "";
      if (ootControl) {
        ootControl.setErrors(null);
      }
    }
    // Check if any field has an error

    const hasError = Object.values(this.errors_feedback).some(
      (error) => error !== ""
    );
    this.errorExist = hasError;
    if (hasError) {
      control.setErrors({ invalidMetrics: this.errors_feedback });
    } else {
      control.setErrors(null);
    }

    this.errors_feedback = this.errors_feedback;
    
  }

  // Calculate the sum of each metric across all platforms
  calculateSumOfMetrics() {
    return this.platforms.controls.reduce(
      (sum, platform: any) => {
        sum.leads_delivered += Number(platform.get("leads_delivered").value) || 0;
        sum.feedback_received += Number(platform.get("feedback_received").value) || 0;
        sum.leads_qualified += Number(platform.get("leads_qualified").value) || 0;
        const ootValue = Number(platform.get("leads_qualified_out_of_tat").value);
        sum.leads_qualified_out_of_tat +=
          ootValue !== null && ootValue !== undefined && ootValue !== 0
            ? ootValue
            : 0;
        // sum.leads_qualified_out_of_tat += platform.get('leads_qualified_out_of_tat').value || 0;
        sum.site_visit_proposed +=
        Number(platform.get("site_visit_proposed").value) || 0;
        sum.site_visit_done += Number(platform.get("site_visit_done").value) || 0;
        sum.csql += Number(platform.get("csql").value) || 0;
        return sum;
      },
      {
        leads_delivered: 0,
        feedback_received: 0,
        leads_qualified: 0,
        leads_qualified_out_of_tat: 0,
        site_visit_proposed: 0,
        site_visit_done: 0,
        csql: 0,
      }
    );
  }

  onPaste(event: ClipboardEvent, startIndex: number) {
    
    event.preventDefault();
    const clipboardData = event.clipboardData.getData("text");
    if (!clipboardData) return;

    const rows = clipboardData.split("\n").filter((row) => row.trim() !== "");

    for (let i = 0; i < rows.length; i++) {
      const rowValues = rows[i].split("\t").map((v) => v.trim());
      const index = startIndex + i;
      if (i == 0) {
        if (rowValues[1]) {
          this.addForm.get("leads_delivered").setValue(rowValues[1]);
        }
        if (rowValues[2]) {
          this.addForm.get("feedback_received").setValue(rowValues[2]);
        }
        if (rowValues[3]) {
          this.addForm.get("leads_qualified").setValue(rowValues[3]);
        }
        if (rowValues[4]) {
          this.addForm.get("leads_qualified_out_of_tat").setValue(rowValues[4]);
        }
        if (rowValues[5]) {
          this.addForm.get("site_visit_proposed").setValue(rowValues[5]);
        }
        if (rowValues[6]) {
          this.addForm.get("site_visit_done").setValue(rowValues[6]);
        }
        if (rowValues[7]) {
          this.addForm.get("csql").setValue(rowValues[7]);
        }
        this.platformForm.setValidators(this.validateMetricsMatch.bind(this));
      }
      if (i > 0) {
        const group = this.platforms.at(i - 1);
        if (rowValues[0]) {
          group.get("platform").setValue(rowValues[0]);
        }
        if (rowValues[1]) {
          group.get("leads_delivered").setValue(rowValues[1]);
        }
        if (rowValues[2]) {
          group.get("feedback_received").setValue(rowValues[2]);
        }
        if (rowValues[3]) {
          group.get("leads_qualified").setValue(rowValues[3]);
        }
        if (rowValues[4]) {
          group.get("leads_qualified_out_of_tat").setValue(rowValues[4]);
        }
        if (rowValues[5]) {
          group.get("site_visit_proposed").setValue(rowValues[5]);
        }
        if (rowValues[6]) {
          group.get("site_visit_done").setValue(rowValues[6]);
        }
        if (rowValues[7]) {
          group.get("csql").setValue(rowValues[7]);
        }
        this.platformForm.setValidators(this.validateMetricsMatch.bind(this));
      }
     
    }
    this.leadDelivered();
    
  }
}
